import customerAutocompleteComponent from './customer-autocomplete.component';

const customerAutocompleteModule = angular.module('customerAutocomplete', [
])
  .component('customerAutocomplete', customerAutocompleteComponent)
  .name;

export default customerAutocompleteModule;
